export class ApiClientError extends Error {
    constructor(message, status, code) {
        super(message);
        this.name = 'ApiClientError';
        this.status = status;
        this.code = code;
    }
}
class ApiClient {
    constructor(baseUrl = '/api') {
        this.csrfToken = null;
        this.baseUrl = baseUrl;
    }
    setCsrfToken(token) {
        this.csrfToken = token;
    }
    getCsrfToken() {
        return this.csrfToken;
    }
    async request(endpoint, options = {}) {
        const { method = 'GET', body, headers = {} } = options;
        const requestHeaders = {
            'Content-Type': 'application/json',
            ...headers,
        };
        if (this.csrfToken && ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
            requestHeaders['X-CSRF-Token'] = this.csrfToken;
        }
        const response = await fetch(`${this.baseUrl}${endpoint}`, {
            method,
            headers: requestHeaders,
            body: body ? JSON.stringify(body) : undefined,
            credentials: 'include',
        });
        // Handle CSRF token from response headers
        const newCsrfToken = response.headers.get('X-CSRF-Token');
        if (newCsrfToken) {
            this.csrfToken = newCsrfToken;
        }
        if (!response.ok) {
            let errorData = {};
            try {
                errorData = await response.json();
            }
            catch {
                // Response body might not be JSON
            }
            throw new ApiClientError(errorData.message || `Request failed with status ${response.status}`, response.status, errorData.code);
        }
        // Handle 204 No Content
        if (response.status === 204) {
            return undefined;
        }
        return response.json();
    }
    async get(endpoint, headers) {
        return this.request(endpoint, { method: 'GET', headers });
    }
    async post(endpoint, body, headers) {
        return this.request(endpoint, { method: 'POST', body, headers });
    }
    async put(endpoint, body, headers) {
        return this.request(endpoint, { method: 'PUT', body, headers });
    }
    async patch(endpoint, body, headers) {
        return this.request(endpoint, { method: 'PATCH', body, headers });
    }
    async delete(endpoint, headers) {
        return this.request(endpoint, { method: 'DELETE', headers });
    }
}
// Singleton instance
export const apiClient = new ApiClient();
